import { render, staticRenderFns } from "./ViewsTable.vue?vue&type=template&id=6a5ba2cf&"
import script from "./ViewsTable.vue?vue&type=script&lang=js&"
export * from "./ViewsTable.vue?vue&type=script&lang=js&"
import style0 from "./ViewsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports